import styled, { css } from 'styled-components'

export const DesktopContainer = styled.div`
  display: none;

  ${({ theme }) => css`
    ${theme.media.up.md} {
      display: block;
    }
  `}
`

export const MobileContainer = styled.div`
  display: none;

  ${({ theme }) => css`
    ${theme.media.down.md} {
      display: block;
    }
  `}
`
